import Storage from './Storage';

/**
 * Store UserData
 * 
 */
class UserData extends Storage {
    storeName = 'user_data_';
    hasOldKey = true;

    /**
     * UserData constructor
     * 
     * @param {string} id client id
     */
     constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

    /**
     * @override
     * 
     * Format data for store
     * 
     * @param {*} data data to store
     * @returns 
     */
     formatSetDataOld(data) {
        let returnData = JSON.stringify(data.data);
        return returnData;
    }

}

export default UserData;